import React from 'react'
import cn from 'classnames'
import { Cell } from 'styled-css-grid'
import OrganizationLogo from '@ui/OrganizationLogo'
import LanguageSelector from '@ui/LanguageSelector'
import useScrollHideNavbar from '@hooks/useScrollHideNavbar'
import useIsWindowScrolled from '@hooks/useIsWindowScrolled'

const TopNav = ({ className, children, dir }) => {
  const navbarId = 'top-navbar'
  useScrollHideNavbar(navbarId, 67)

  return (
    <Cell
      area='topNav'
      className={cn('nav top-nav', className, {
        'hide-border': !useIsWindowScrolled()
      })}
      id={navbarId}
    >
      <div className='flex align-top top-nav-brand'>
        <OrganizationLogo />
        <div className='show-responsive'>
          <LanguageSelector sm />
        </div>
      </div>
      {children}
    </Cell>
  )
}

export default TopNav
